import { render, staticRenderFns } from "./Step3AboutEstablishment.vue?vue&type=template&id=2e7a5d1c&scoped=true"
import script from "./Step3AboutEstablishment.vue?vue&type=script&lang=js"
export * from "./Step3AboutEstablishment.vue?vue&type=script&lang=js"
import style0 from "./Step3AboutEstablishment.vue?vue&type=style&index=0&id=2e7a5d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a5d1c",
  null
  
)

export default component.exports